export const ROOT = '/guards';
export const MODULE = 'GUARDS';
